import React, { useState, useEffect } from 'react';
import { studyMaterialService } from '../../services/api';
import { BookOpenIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

const StudyMaterials = () => {
  const [materials, setMaterials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMaterials();
  }, []);

  const fetchMaterials = async () => {
    try {
      const response = await studyMaterialService.getAll();
      setMaterials(response.data.data || []);
    } catch (error) {
      console.error('Error fetching materials:', error);
      toast.error('Failed to load study materials');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (material) => {
    toast.success(`Downloading ${material.title}...`);
    // In production, this would trigger actual download
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Study Materials</h1>
      <div className="space-y-4">
        {materials.length === 0 ? (
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8 text-center text-gray-500">
            No study materials available
          </div>
        ) : (
          materials.map((material, index) => (
            <div key={material._id || index} className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 hover:shadow-md transition flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="p-3 bg-blue-50 rounded-lg">
                  <BookOpenIcon className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800">{material.title}</h3>
                  <p className="text-sm text-gray-500">
                    {material.subject} • {material.type || 'PDF'} • {material.size || 'N/A'}
                  </p>
                </div>
              </div>
              <button
                onClick={() => handleDownload(material)}
                className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition"
              >
                <ArrowDownTrayIcon className="h-5 w-5" />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default StudyMaterials;
